<div class="col-md-12 topBar">
  <div class="row m-0 p-0" style="height: 50px;">
    <div class=" col-md-5 headerClasss row m-0 p-0">
      <div class="logoClass" style="margin-top: 10px;margin-bottom: 10px;width: 168px;border-right: 1.5px solid white;">
        <img class="capelogo" src="assets/cape-logo-new.png" alt="CAPE Logo">
      </div>
      <div class="col headerLabelClass">Trust Centre</div>
    </div>

    <div class="col-md-2 m-0 p-0"></div>
    <div class="col-md-5 m-0 p-0">
      <div class="row m-0 p-0 h-100">
        <div class="col-md-4 m-0 p-0">
          <div class="moveMenu row m-0 p-0">
            <button class="btnsignin" (click)="signin()">Sign in</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="row m-0 p-0" id="banner-sol">
  <div class="col-md-6 text-left pl-5 ">
    <h1 id="sol-b-head" class="mt-5">Welcome to TCS Enterprise Manager Trust Centre!</h1>
    <p class="b-sh">Our products and services are crafted with a commitment to security, privacy, compliance, and
      transparency at their core. Here, you'll find documents outlining our policies that reflect these principles. For
      access to private documents, simply use the credentials provided in your order form.​</p>

    <!-- <div class="text-start ml-5"> -->
    <button role="button" class="schBtn1 m-4 pl-5" (click)="publicDoc()">
      Public Documents
    </button>
    <button role="button" class="schBtn " (click)="signin()">Private Documents</button>
    <!-- </div> -->
  </div>
  <div class="col-md-6 ">
    <img src="assets/landingpage-banner.png" class="img-fluid" id="sol-b-img">
  </div>
</div>

<!-- <div class="row m-0 p-0">
  <div class="col-md-12 text-left mt-3 ml-5">
    <h1 id="document-title"> Documents</h1>
  </div>
</div> -->

<!-- <div class="row m-0 p-0">
  <div class="col-md-12 text-left mt-3 ml-5">
    <h1 class="sol-b-head-n"> Documents</h1>
  </div>
</div> -->

<!-- <div class="row cards-hz ml-0 mr-0 mt-2 rounded" id="card1">
  <div class="col-md-3">
    <img src="assets/documents-image.png" class="img-fluid card-img-c">
  </div>
  <div class="col-md-9 text-start">
    <p class="card-para pt-5 mt-1 mb-2"> Click Public Documents to view or download the documents. Public documents can
      be accessed by anyone visiting the Trust Center.
      Click Private Documents to view or download the documents. Private documents require log in with valid TCS
      Enterprise Manager credentials.
    </p>
    <div class="text-center">
      <button role="button" class="schBtn1" (click)="publicDoc()">
        Public Documents
      </button>
      <button role="button" class="schBtn" (click)="signin()">Private Documents</button>
    </div>
  </div>
</div> -->

<!-- <div class="row m-0 p-0"> -->
<!-- <div class="col-md-12 text-center mt-3 ml-5"> -->
<p class="text-center text-muted font-12p mt-5 pt-5"> &copy; Tata Consultancy Services Limited. All Rights Reserved.</p>
<!-- </div>
</div> -->
